<plyca-ui-checkbox
  [config]="{
    id: 'basicCheckbox',
    label: 'Accept Terms & Conditions',
    disabled: false
  }"
/>
